import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHelp } from './Help.hooks';
import * as S from './Questions/Questions.styles';
import { PageTopControls } from '@/components/PageTopControls';
import { Footer } from '@/components/Footer/Footer';
import { Tabs } from '@/components/Tabs/Tabs';
import { Questions } from '@/views/Help/Questions/Questions';
import { Header } from '@/components/Header';
import { ErrorView } from '@/views/Error/Error.view';
import { Spinner } from '@/components/Spinner/Spinner';

export const HelpView = () => {
  const { t } = useTranslation();
  const {
    title,
    tabs,
    questions,
    isLoading,
    isError,
    isNotFound,
    handleCategorySelect,
    handleRetry,
  } = useHelp();

  if (isNotFound) return <ErrorView statusCode={404} hasFooter />;

  if (isError) {
    return <ErrorView statusCode={500} onClick={handleRetry} hasFooter />;
  }

  return (
    <>
      <PageTopControls>
        <Header title={t('common.help')} hasBurger />
        <Tabs
          tabs={tabs}
          onTabCLick={handleCategorySelect}
          shape="rounded"
          hasTopPadding
          isCompareWithHash={false}
        />
      </PageTopControls>

      {isLoading ? (
        <S.Loading role="status" aria-busy="true">
          <Spinner size="m" />
        </S.Loading>
      ) : (
        <Questions title={title} questions={questions} />
      )}

      <Footer />
    </>
  );
};
